import React from "react";

import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PortfolioProject from "./portfolio/PortfolioProject.js"

const Portfolio = () => {
  
  const getProjectKey = (location) => {
    return location.pathname.split("/").pop()
  }
  
  const navigate = useNavigate();
  const location = useLocation();
  const [pageState, setPageState] = useState("loading");
  const [dynamicContent, setDynamicContent] = useState(null);

  const pageContent = {
    loading: <>
      <h1>Loading data...</h1>
    </>,
    error: <>
      <h1>There has been an issue.</h1>
    </>,
    success: dynamicContent
  };

  useEffect(() => {(async () => {
    try {
      const res = await fetch("https://oncadevelopment.com/api/project");
      if (!res.ok) throw new Error("Failed to fetch projects");
      const data = await res.json();
      const pages = data.map(item => item.page_link);
      let currentAddress = getProjectKey(location);

      if (!pages.includes(currentAddress)) {
        console.log("current url is not valid");
        navigate(`./${data[0].page_link}`, { replace: true })
        currentAddress = data[0].page_link
      }

      const idx = data.findIndex(item => item.page_link === currentAddress);
      console.log(idx);
      const project = data[idx];
      const prevIdx = (idx - 1 + data.length) % data.length;
      const nextIdx = (idx + 1 + data.length) % data.length;

      setDynamicContent(<>
        <h1>Our experience</h1>
        <PortfolioProject 
          title={ project.name }
          location={ project.location }
          services={ project.services }
          description={ project.description }
        >
        </PortfolioProject>
        <nav>
          <ul>
            {
              data.map((item, index) => {
                return <li key={ index }>
                  <Link 
                    to={ `./${item.page_link}` } 
                    className={ item.page_link === currentAddress ? "active" : ""}>{ item.name }</Link>
                </li>
              })
            }
          </ul>
          <div className="buttons">
            <Link to={`./${data[prevIdx].page_link}`}>{'<'} Prev</Link>
            <Link to={`./${data[nextIdx].page_link}`}>Next {'>'}</Link>
          </div>
        </nav>
      </>)
      setPageState("success")

    } catch (err) {
      console.error(err)
      setPageState("error")
    }
  })()}, [location]);
 
  return <>
    <main id="portfolio-page">
      <Link className="breadcrumb" to="..">{"<"} Back to home page</Link>
      { pageContent[pageState] }
    </main>
    <footer>
      <Link to="/contact">
        <button>Have a project? Let's talk 👉</button>
      </Link>
    </footer>
  </>
}

export default Portfolio;